import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[ui-button-round]',
})
export class UiButtonRoundDirective {
  constructor() {}
  @HostBinding('class') elementClass = 'ui-button-round';
}
